import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { usePostForgotPasswordMutation } from "../../service/auth";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [forgetPasswordMutation] = usePostForgotPasswordMutation();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address"
        ),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      const body = {
        email: values.email,
        otpType: 3,
      };

      try {
        setLoading(true);
        const response = await forgetPasswordMutation(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          navigate("/otp?type=forgotPassword", {
            state: { email: formik.values.email },
          });
          showToast("OTP sent successfully");
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  return (
    <AuthLayout>
      <Loader isLoad={loading} />
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p>Please provide your email address to reset your password</p>

        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              className="text_field"
              placeholder="Enter Email Address"
              fullWidth
              value={formik.values.email}
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                } else {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.email && typeof formik.errors.email === "string"
                  ? formik.errors.email
                  : ""
              }
            />
          </div>

          <div className="form_btn">
            <Button type="submit" className="btn btn_primary w_100">
              Submit
            </Button>
          </div>
        </form>

        <div className="auth_bottom">
          <p>
            <button
              type="button"
              className="link"
              onClick={() => navigate("/")}
            >
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
